<div class="simple-dialog-container">
  <!-- Close Icon -->
  <i [mat-dialog-close] class="pi pi-times close-icon"></i>

  <!-- Title -->
  <h2 class="dialog-title">Empresas gestionadas</h2>
  <p>Listado de empresas asignadas para gestionar.</p>

  <div class="dialog-container">
    <table mat-table [dataSource]="dataSource" class="table">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <!--? matColumnDef identifica de manera unica la columna con una key  -->
      <ng-container matColumnDef="managedCompany">
        <th mat-header-cell *matHeaderCellDef class="blue bold theader">
          Card code
        </th>
        <td mat-cell *matCellDef="let company" class="mt">
          {{ company.managedCompany }}
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef class="blue bold theader">
          Empresa
        </th>

        <td mat-cell *matCellDef="let company" class="mt">
          {{ company.company }}
        </td>
      </ng-container>
    </table>
  </div>
</div>
